import { createSlice } from '@reduxjs/toolkit';
import { transformResourceKeys } from './utils';

export const initialStateDrawerData = {
    profile: '',
    connectedApps: { data: [], isLoading: false, errors: '' },
    allConnectedApps: { data: [], isLoading: false, errors: '' },
    resources: [],
    rolesList: { data: [], isLoading: false, errors: '' },
    selectedRole: {},
    assignAllCompanies: false,
    assignAllSites: false,
    saveData: { data: '', isLoading: false, errors: '' },
    shouldShowAlert: false,
    shouldShowResourcesAlert: false,
};
export const initialState = {
    subscribers: {
        rows: [],
        isLoading: false,
        errors: '',
    },
    editSubscriberDrawerData: initialStateDrawerData,
    showEnableSubscriberModal: false,
    disableSubscription: {
        subscriberId: '',
    },
    enableSubscription: {},
    showDisableSubscriberModal: false,
    showEditSubscriberDrawer: false,
};

export const subscribersSliceId = 'subscribers';

const slice = createSlice({
    name: subscribersSliceId,
    initialState,
    reducers: {
        fetchSubscribers(state) {
            state.subscribers = {
                ...state.subscribers,
                rows: [],
                isLoading: true,
                errors: '',
            };
        },
        fetchSubscribersSuccess(state, action) {
            const { rows } = action.payload;

            state.subscribers = {
                ...state.subscribers,
                rows,
                isLoading: false,
                errors: '',
            };
        },
        fetchSubscribersFailure(state, action) {
            const { error } = action.payload;
            state.subscribers = {
                ...state.subscribers,
                rows: [],
                isLoading: false,
                errors: error,
            };
        },
        fetchAsioRolesForSubscribers(state) {
            state.editSubscriberDrawerData.connectedApps = {
                ...state.editSubscriberDrawerData.connectedApps,
                data: [],
                isLoading: true,
                errors: '',
            };
        },
        fetchAsioRolesForSubscribersSuccess(state, action) {
            const { data } = action.payload;
            state.editSubscriberDrawerData.selectedRole = {
                label: data?.connectedApps?.[0]?.applicationRoles?.[0]?.displayName,
                value: data?.connectedApps?.[0]?.applicationRoles?.[0]?.roleId,
            };
            state.editSubscriberDrawerData.connectedApps = {
                ...state.editSubscriberDrawerData.connectedApps,
                data,
                isLoading: false,
                errors: '',
            };
            const resourcesInit = data?.connectedApps?.[0]?.applicationRoles?.[0]?.assignedResources ?? [];
            const resourcesData = transformResourceKeys(resourcesInit);
            state.editSubscriberDrawerData.resources = resourcesData;
        },
        fetchAsioRolesForSubscribersFailure(state, action) {
            const { error } = action.payload;
            state.editSubscriberDrawerData.shouldShowAlert = true;
            state.editSubscriberDrawerData.connectedApps = {
                ...state.editSubscriberDrawerData.connectedApps,
                data: [],
                isLoading: false,
                errors: error,
            };
        },
        fetchAsioRolesListForSubscribers(state) {
            state.editSubscriberDrawerData.rolesList = {
                ...state.editSubscriberDrawerData.rolesList,
                data: [],
                isLoading: true,
                errors: '',
            };
        },
        fetchAsioRolesListForSubscribersSuccess(state, action) {
            const { data } = action.payload;

            state.editSubscriberDrawerData.rolesList = {
                ...state.editSubscriberDrawerData.rolesList,
                data,
                isLoading: false,
                errors: '',
            };
        },
        fetchAsioRolesListForSubscribersFailure(state, action) {
            const { error } = action.payload;
            state.editSubscriberDrawerData.shouldShowAlert = true;
            state.editSubscriberDrawerData.rolesList = {
                ...state.editSubscriberDrawerData.rolesList,
                data: [],
                isLoading: false,
                errors: error,
            };
        },
        saveRole(state) {
            state.editSubscriberDrawerData.saveData = {
                ...state.editSubscriberDrawerData.saveData,
                data: '',
                isLoading: true,
                errors: '',
            };
        },
        saveRoleSuccess(state, action) {
            const { data } = action.payload;
            state.editSubscriberDrawerData.saveData = {
                ...state.editSubscriberDrawerData.saveData,
                data,
                isLoading: false,
                errors: '',
            };
            state.showEditSubscriberDrawer = false;
            state.editSubscriberDrawerData = initialStateDrawerData;
        },
        saveRoleFailure(state, action) {
            const { error } = action.payload;
            state.editSubscriberDrawerData.shouldShowAlert = true;
            state.editSubscriberDrawerData.saveData = {
                ...state.editSubscriberDrawerData.saveData,
                data: '',
                isLoading: false,
                errors: error,
            };
        },
        //For future use case
        // disableSubscription(state) {
        //     state.disableSubscription = {
        //         ...state.disableSubscription,
        //         data: '',
        //         isLoading: true,
        //         errors: '',
        //     };
        // },
        // disableSubscriptionSuccess(state, action) {
        //     const { data } = action.payload;
        //     state.disableSubscription = {
        //         data,
        //         isLoading: false,
        //         errors: '',
        //     };
        //     state.showDisableSubscriberModal = false;
        // },
        // disableSubscriptionFailure(state, action) {
        //     const { error } = action.payload;
        //     state.disableSubscription = {
        //         ...state.disableSubscription,
        //         data: '',
        //         isLoading: false,
        //         errors: error,
        //     };
        // },
        fetchConnectedAppsWithResources(state, action) {
            state.editSubscriberDrawerData.allConnectedApps = {
                ...state.editSubscriberDrawerData.allConnectedApps,
                data: [],
                isLoading: true,
                errors: '',
            };
        },
        fetchConnectedAppsWithResourcesSuccess(state, action) {
            const { data } = action.payload;
            state.editSubscriberDrawerData.allConnectedApps = {
                ...state.editSubscriberDrawerData.allConnectedApps,
                data,
                isLoading: false,
                errors: '',
            };
        },
        fetchConnectedAppsWithResourcesFailure(state, action) {
            const { error } = action.payload;
            state.editSubscriberDrawerData.allConnectedApps = {
                ...state.editSubscriberDrawerData.allConnectedApps,
                data: [],
                isLoading: false,
                errors: error,
            };
        },
        resetDrawerState: state => {
            state.editSubscriberDrawerData = initialStateDrawerData;
        },
        updateSelectedRole: (state, action) => {
            const { selectedRole } = action.payload;
            state.editSubscriberDrawerData.selectedRole = { ...selectedRole };
        },
        toggleEnableSubscriberModal: (state, action) => {
            const { isOpen } = action.payload;
            state.showEnableSubscriberModal = isOpen;
        },
        toggleDisableSubscriberModal: (state, action) => {
            const { isOpen, subscriberId } = action.payload;
            state.showDisableSubscriberModal = isOpen;
            state.disableSubscription.subscriberId = subscriberId ?? '';
        },
        toggleEditSubscriberDrawer: (state, action) => {
            const { isOpen, selectedRow } = action.payload;
            state.showEditSubscriberDrawer = isOpen;
            state.editSubscriberDrawerData.profile = selectedRow;
        },
        toggleAlert: (state, action) => {
            const { isOpen } = action.payload;
            state.editSubscriberDrawerData.shouldShowAlert = isOpen;
        },
        toggleResourcesAlert: (state, action) => {
            const { isOpen } = action.payload;
            state.editSubscriberDrawerData.shouldShowResourcesAlert = isOpen;
        },
        setSelectedResources: (state, action) => {
            const { selectedResources, assignAllSites, assignAllCompanies } = action.payload;
            state.editSubscriberDrawerData.resources = selectedResources;
            state.editSubscriberDrawerData.assignAllSites = assignAllSites;
            state.editSubscriberDrawerData.assignAllCompanies = assignAllCompanies;
        },
    },
});

export const {
    fetchSubscribers,
    fetchSubscribersSuccess,
    fetchSubscribersFailure,
    fetchAsioRolesForSubscribers,
    fetchAsioRolesForSubscribersSuccess,
    fetchAsioRolesForSubscribersFailure,
    fetchAsioRolesListForSubscribers,
    fetchAsioRolesListForSubscribersSuccess,
    fetchAsioRolesListForSubscribersFailure,
    saveRole,
    saveRoleSuccess,
    saveRoleFailure,
    disableSubscription,
    disableSubscriptionSuccess,
    disableSubscriptionFailure,
    fetchConnectedAppsWithResources,
    fetchConnectedAppsWithResourcesSuccess,
    fetchConnectedAppsWithResourcesFailure,
    toggleEnableSubscriberModal,
    toggleDisableSubscriberModal,
    toggleEditSubscriberDrawer,
    updateSelectedRole,
    resetDrawerState,
    toggleAlert,
    toggleResourcesAlert,
    setSelectedResources,
} = slice.actions;

export default slice.reducer;
